import { FONT_WEIGHT } from '../../foundations/typography';
import { getDefaultStyles } from './variantStyles/default';
import { getMainSectionStyles } from './variantStyles/mainSection';
import { getRegularStyles } from './variantStyles/regular';
import { DotSizeType } from './variants';
const sizeCommonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        width: 'fit-content',
        height: 'fit-content',
        padding_left: FOUNDATIONS.spacing_50,
        padding_right: FOUNDATIONS.spacing_50,
        font_family: `${FOUNDATIONS.font_family_paragraph}, sans-serif`,
        font_weight: FONT_WEIGHT.font_weight_600,
    },
});
export const getDotStyles = (FOUNDATIONS, FONT) => {
    return {
        ...getDefaultStyles(FOUNDATIONS, FONT),
        ...getRegularStyles(FOUNDATIONS, FONT),
        ...getMainSectionStyles(FOUNDATIONS, FONT),
        [DotSizeType.SMALL]: {
            container: {
                ...sizeCommonStyles(FOUNDATIONS, FONT).container,
                min_height: FOUNDATIONS.size_comp_resources_dot_size_small,
                min_width: FOUNDATIONS.size_comp_resources_dot_size_small,
                font_size: FOUNDATIONS.font_exception_size_paragraph_dot,
                line_height: FOUNDATIONS.font_exception_line_height_paragraph_dot,
            },
        },
        [DotSizeType.MEDIUM]: {
            container: {
                ...sizeCommonStyles(FOUNDATIONS, FONT).container,
                min_height: FOUNDATIONS.size_comp_resources_dot_size_medium,
                min_width: FOUNDATIONS.size_comp_resources_dot_size_medium,
                font_size: FOUNDATIONS.font_comp_resources_dot_fontsize_medium,
                line_height: FOUNDATIONS.font_comp_resources_dot_fontlineheight_medium,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map